import React, { useEffect, useState, useRef } from 'react'
import NoticeBoard from '../components/NoticeBoard'
import CardInfo from '../components/CardInfo'
import NewsShot from '../components/NewsShot'
import TabTittle from '../components/TabTittle'
import Iframe from 'react-iframe'
import axios from 'axios'
import Skeleton from 'react-loading-skeleton'
import SkliPhotoGlry from '../components/skeletonComp/Skli_PgotoGlry'
import ToploaderBar from '../components/ToploaderBar'
import VideoGallery from '../components/VideoGallery'


const videoUrls = [
  // 'https://www.youtube.com/embed/W9SB53E-r6k',
  // 'https://www.youtube.com/embed/l7G3TPz6P24',
  // 'https://www.youtube.com/embed/l_a2YQcG3GU',
  // 'https://www.youtube.com/embed/z6llDxY5JFs',
  // 'https://www.youtube.com/embed/GT9ShGE_qjg',
];

function Home() {
  TabTittle("জেলা পরিষদ, রাজশাহী।")
  const APICoverPhoto = `https://zprajshahi.gov.bd/zpr/data/cover_photo`
  const API_Masquee_text = `https://zprajshahi.gov.bd/zpr/data/slider_text`
  const ApiCoverPhotoUrl = `https://zprajshahi.gov.bd/zpr/assets/cover_photo/`
  const ApiGalleryPhotos = `https://www.zprajshahi.gov.bd/zpr/data/gallery`;
  const APIimgUrl = `https://www.zprajshahi.gov.bd/zpr/assets/zprgallery/`
  const [mainCoverPhhoto, setMainCoverPhoto] = useState([])
  const [isLoading1, setIsLoading1] = useState(true)
  const [mainGalleryPhhoto, setMainGalleryPhhoto] = useState([])
  const [isLoading2, setIsLoading2] = useState(true)
  const [mainMarqueeData, setMarqueeData] = useState([])
  const [isLoadingMarqueeData, setLoadingMarqueeData] = useState(true)
  
  // Gallery images ke alada state e rakhbo jate splice korle original data na jay
  const [displayedGalleryPhotos, setDisplayedGalleryPhotos] = useState([]);
  
  const fatchAllData = async () => {
    const getCoverPhotoAPI = axios.get(APICoverPhoto)
    const getApiGalleryPhotos = axios.get(ApiGalleryPhotos)
    const getApiMarqueTex = axios.get(API_Masquee_text)

    axios.all([getCoverPhotoAPI, getApiGalleryPhotos, getApiMarqueTex]).then(
      axios.spread((...allAPIData) => {
        const coverPhotoAPIData = allAPIData[0].data
        setMainCoverPhoto(coverPhotoAPIData)
        setIsLoading1(false)
        const GalleryAPIData = allAPIData[1].data
        setMainGalleryPhhoto(GalleryAPIData)
        // First 4 images display korar jonno
        setDisplayedGalleryPhotos(GalleryAPIData.slice(0, 4))
        setIsLoading2(false)
        const MarqueeData = allAPIData[2].data
        setMarqueeData(MarqueeData)
        setLoadingMarqueeData(false)
      })
    )
  }


  useEffect(() => {
    fatchAllData()
  }, [])
  
  // ------Image Popup------------
  const [model, setModel] = useState(false)
  const [tempimgSrc, setTempimgSrc] = useState('')
  
  // Model open/close hole body overflow handle korbe
  useEffect(() => {
    if (model) {
      // Model open hole body overflow hide korbo
      document.body.style.overflow = 'hidden';
    } else {
      // Model close hole body overflow restore korbo
      document.body.style.overflow = 'auto';
    }
    
    // Cleanup function
    return () => {
      document.body.style.overflow = 'auto';
    };
  }, [model]);
  
  const getSingleImgURL = (url) => {
    setTempimgSrc(url)
    setModel(true)
  }
  
  const closeModel = () => {
    setModel(false)
    setTempimgSrc('')
  }
  
  // ESC key press korle model close hobe
  useEffect(() => {
    const handleEscKey = (event) => {
      if (event.keyCode === 27) {
        closeModel();
      }
    };
    
    window.addEventListener('keydown', handleEscKey);
    
    return () => {
      window.removeEventListener('keydown', handleEscKey);
    };
  }, []);



  return (
    <>
      <ToploaderBar />
      <div className='colam'>
        {
          mainMarqueeData.map(e => {
            return (
              <>
                <marquee behavior="smooth" direction="" className="mb-2 marqeeText" >
                  {e.slider_text}
                </marquee>
              </>
            )
          })
        }
        {
          isLoading1
            ?
            <>
              <Skeleton width={'100%'} height={'350px'} />
              <br />
            </>
            :
            <>
              <div className="bigImage">
                <img src={ApiCoverPhotoUrl + mainCoverPhhoto[0].image} alt="" />
              </div>

            </>
        }
        <div className="notifactionPart">
          <NoticeBoard name={"cxvxg"} />
        </div>
        <div className="InfoCardsPart">
          <CardInfo />
        </div>
        <br />
        <div className="photoGy">
          <div className="tittle">
            <h2>ফটো গ্যালারী</h2>
          </div>
          
          {/* Modal/Image Popup */}
          {model && (
            <div className="modelSingleImg open" onClick={closeModel}>
              <div className="cls_btn" onClick={(e) => {
                e.stopPropagation();
                closeModel();
              }}>×</div>
              <div className="img" onClick={(e) => e.stopPropagation()}>
                <img src={tempimgSrc} alt="Full size" />
              </div>
            </div>
          )}
          
          <div className="imgBox">
            {
              isLoading2
                ?
                <SkliPhotoGlry />
                :
                <>
                  {
                    displayedGalleryPhotos.map((e) => {
                      const { image, s_cat } = e
                      return (
                        <div className="card" key={image}>
                          <div className="imgPart" onClick={() => getSingleImgURL(APIimgUrl + image)} >
                            <img src={APIimgUrl + image} alt={s_cat} />
                          </div>
                          <div className="tittle">{s_cat}</div>
                        </div>
                      )
                    })
                  }
                </>
            }
          </div>
        </div>
        <VideoGallery videoUrls={videoUrls} />
      </div>
      {/* CSS styles add korbo component er upore */}
      <style jsx="true">{`
        .modelSingleImg {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background-color: rgba(0, 0, 0, 0.9);
          display: flex;
          justify-content: center;
          align-items: center;
          z-index: 1000;
          opacity: 0;
          visibility: hidden;
          transition: opacity 0.3s ease, visibility 0.3s ease;
        }
        
        .modelSingleImg.open {
          opacity: 1;
          visibility: visible;
        }
        
        .modelSingleImg .cls_btn {
          position: absolute;
          top: 20px;
          right: 30px;
          font-size: 40px;
          color: white;
          cursor: pointer;
          z-index: 1001;
          transform: rotate(45deg);
          transition: transform 0.3s ease;
          width: 40px;
          height: 40px;
          display: flex;
          justify-content: center;
          align-items: center;
          line-height: 1;
        }
        
        .modelSingleImg .cls_btn:hover {
          transform: rotate(135deg);
        }
        
        .modelSingleImg .img {
          max-width: 90%;
          max-height: 90%;
          display: flex;
          justify-content: center;
          align-items: center;
        }
        
        .modelSingleImg .img img {
          max-width: 100%;
          max-height: 100%;
          object-fit: contain;
          border-radius: 8px;
        }
      `}</style>
    </>
  )
}

export default Home